import http from './http'

const base = '/Telas/BaixasRateios'

export default {
  async get (params) { return (await http.get(`${base}/Get`, { params })).data },
  async getByPayment (paymentId) { return (await http.get(`${base}/GetByPayment/${paymentId}`)).data },
  async getCandidates (paymentId, params) { return (await http.get(`${base}/GetCandidates/${paymentId}`, { params })).data },
  async getOptions () { return (await http.get(`${base}/GetOptions`)).data },
  async allocate (paymentId, input) { return (await http.post(`${base}/Allocate/${paymentId}`, input)).data },
  async reverse (allocationId, input) { return (await http.post(`${base}/Reverse/${allocationId}`, input)).data },
  async reallocate (allocationId, input) { return (await http.post(`${base}/Reallocate/${allocationId}`, input)).data }
}
